import { FiAward, FiZap, FiCheckCircle, FiBriefcase, FiUsers } from "react-icons/fi";
import { HiOutlineLightBulb } from "react-icons/hi";

const gains = [
  {
    icon: <FiAward size={32} className="text-orange-500" />,
    title: "Personalized Strategies",
    desc: "Receive step-by-step, actionable tips tailored to your specific interview challenges.",
  },
  {
    icon: <FiZap size={32} className="text-orange-500" />,
    title: "Boost Your Confidence",
    desc: "Move past anxiety and momentary blocks with practical guidance, feeling prepared for anything.",
  },
  {
    icon: <HiOutlineLightBulb size={32} className="text-orange-500" />,
    title: "Expert Insights",
    desc: "Benefit from my experience as a software engineer to navigate your placement journey effectively.",
  },
  {
    icon: <FiCheckCircle size={32} className="text-orange-500" />,
    title: "Clear Action Plan",
    desc: "Leave the call with a practical plan to implement immediately, ensuring progress.",
  },
  {
    icon: <FiBriefcase size={32} className="text-orange-500" />,
    title: "Career Advancement",
    desc: "Secure your next role by mastering interview skills and showcasing your true potential.",
  },
  {
    icon: <FiUsers size={32} className="text-orange-500" />,
    title: "Team Player Approach",
    desc: "Leverage my problem-solving skills to tackle your unique career questions.",
  },
];

const WhatYouWillGain = () => (
  <section className="py-16 px-4 sm:px-10 md:px-24 bg-white">
    <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">
      What You Will Gain On CodeQueue
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
      {gains.map((gain, idx) => (
        <div
          key={idx}
          className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-start gap-2 border hover:shadow-lg transition"
        >
            <div>{gain.icon}</div>
          <h3 className="text-lg font-semibold">{gain.title}</h3>
          <p className="text-gray-600 text-sm">{gain.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WhatYouWillGain;